module.exports = __webpack_public_path__ + "static/media/distracted-boyfriend.9f169429.png";